<div class="eau-loader-cover">
    <div class="eau-loader-cover--overlay"></div>
    <eau-loader-spinner></eau-loader-spinner>
</div>